/**
 * Plain axios client for public WP REST calls that aren't part of the
 * WooCommerce Store API (wooClient.js) — currently just the custom
 * raretto/v1 endpoints (track-order, box-discount-tiers) registered by
 * the raretto-headless.php plugin. Both are public (no auth required),
 * so this client carries no credentials.
 */
import axios from 'axios';

const WP_URL = process.env.REACT_APP_WP_URL;

export const wpClient = axios.create({
  baseURL: WP_URL ? `${WP_URL}/wp-json` : undefined,
  timeout: 30_000,
});

if (!WP_URL) {
  // eslint-disable-next-line no-console
  console.warn('[wpClient] REACT_APP_WP_URL is not set.');
}
